export default {"src":"/_next/static/media/patch-management.8f125765.svg","height":532,"width":531,"blurWidth":0,"blurHeight":0};